import Url from './net-http.js'
import store from '../store/index.js'
import axios from 'axios'
import qs from 'qs';
import Router from '../Router/index.js'
import Vue from 'vue'
let v = new Vue();
import { Loading } from 'element-ui';
let loadingInstance1='' ;
/*import ElementUI from 'element-ui';*/
const Http={
  name:{
    token:'',
    sk:''
  },
  doGet(url,parmse,callback,err){
      let self=this
      axios.get(url,parmse).then(
        function (result) {
          callback(result)
          /*self.doThen(url,result,callback,err)*/
        }
      ).catch(function (errs) {
        self.doError(errs,err,url,)
      })
    },
    doLogin(url,parmse,state,lodaing,callback,err){
      let self=this
      var CryptoJS = require("crypto-js");
      var jsonStr = JSON.stringify(parmse);
      var token=localStorage.getItem('a')+localStorage.getItem('d')
      var sk=localStorage.getItem('b')+localStorage.getItem('c')
      const secretKey =sk;
      var afterEncrypt = CryptoJS.DES.encrypt(jsonStr, CryptoJS.enc.Utf8.parse(sk), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString()
      /* console.log(afterEncrypt);*///7D7RsPHmNSlBAaEVgEyE4aL0j1SJtFi9
      var desparmse={
        encryptedData:afterEncrypt
      }
      parmse=state?desparmse:parmse
      loadingInstance1 = Loading.service({ fullscreen: true,target:lodaing });
      axios.post(url,qs.stringify(parmse)).then(function(result){
        self.doThen(url,result,callback,err)
      }) .catch(function(errs){
        loadingInstance1.close();
        loadingInstance1=''
        self.doError(errs,err,url,)
      })
    },
    // 带验证和密钥的
    doPost(url,parmse,state,callback,err){
        let self=this
        var CryptoJS = require("crypto-js");
        var jsonStr = JSON.stringify(parmse);
        // console.log(location.pathname)
        // if (location.pathname == '/view/MapForPic') {
        //   console.log(11111111)
        //   token='Bearer 46f51467-ea53-4281-be6e-35b55bb28867'
        // } else {
        //   console.log(22)
        //   token=localStorage.getItem('token')
        // }
        // var token = "Bearer f5cb8727-c57b-4978-8fbb-65640b2c10c7"
        var token=localStorage.getItem('token')
        var sk=localStorage.getItem('b')+localStorage.getItem('c')
          const secretKey =sk;
        var afterEncrypt = CryptoJS.DES.encrypt(jsonStr, CryptoJS.enc.Utf8.parse(sk), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
        var desparmse={
          encryptedData:afterEncrypt
        }
        parmse=state?desparmse:parmse
        axios.post(url,qs.stringify(parmse),{ headers:{"Authorization":token}}).then(function(result){
          self.doThen(url,result,callback,err)
        }) .catch(function(errs){
          self.doError(errs,err,url,)
        })
    },
    //文件上传post
    doMultipart(url,parmse,callback,err){
      let self=this
      axios.post(url,parmse,{headers: { 'Content-Type': 'multipart/form-data'}}).then(function(result){
        self.doThen(url,result,callback,err)
      }) .catch(function(errs){
        self.doError(errs,err,url,)
      })
    },
    //文件下载
    downloadFile(url, fileName, fileType, data) {
      const self = this;
      // var token=localStorage.getItem('a')+localStorage.getItem('d')
      var token=localStorage.getItem('token')
      axios({
        method: 'post',
        url: url,
        data: qs.stringify(data),
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': token
        }
      }).then(res => { // 处理返回的文件流
        const blob = new Blob([res.data], { type: fileType });//new Blob([res])中不加data就会返回下图中[objece objece] 内容（少取一层）
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }).catch(function (errs) {
        self.doError(errs, url);
      })
    },
    // doUpData(url,Name){
    //     axios({
    //         method: 'get',
    //         url: url,
    //         responseType: 'blob',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         }
    //     }).then(res => { // 处理返回的文件流
    //         const blob = new Blob([res.data]);//new Blob([res])中不加data就会返回下图中[objece objece]内容（少取一层）
    //         let a = Date.now();
    //         const fileName = name+a+'.xls';//下载文件名称
    //         const elink = document.createElement('a');
    //         elink.download = fileName;
    //         elink.style.display = 'none';
    //         elink.href = URL.createObjectURL(blob);
    //         document.body.appendChild(elink);
    //         elink.click();
    //         URL.revokeObjectURL(elink.href); // 释放URL 对象
    //         document.body.removeChild(elink);
    //     })
    // },
    doThen(url,result,callback,err){
      if(loadingInstance1!=''){
        loadingInstance1.close();
        loadingInstance1=''
      }
      /* console.log("result: " + url + '   ' + JSON.stringify(result.data.code))*/
      let data=result.data
      if(data.hasOwnProperty("code")){
        if(data.code==1){
          callback(data)
          if(data.code==''){
            callback(data)
          }else{

          }
        } else {
          function _isMobile() {
            let flag = navigator.userAgent.match(
              /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
          }
          if(data.code === 40001){
            //首次登录不提示
            // var tak=localStorage.getItem('token')
            // if(Router.history.current.name!='Login'&&tak!=null){
            //   v.$message({
            //     showClose: true,
            //     message: data.message,
            //     type: 'warning'
            //   })
            // }
            if (_isMobile()) {
              // 手机端
              Router.push({ path: "/mobile/login"})
            } else {
              // pc端
              if (window.location.host === 'beijing.dtwl360.com') {
                window.location.href = 'https://beijing.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'chongqing.dtwl360.com') {
                window.location.href = 'https://chongqing.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'fujian.dtwl360.com') {
                window.location.href = 'https://fujian.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'henan.dtwl360.com') {
                window.location.href = 'https://henan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'taiwan.dtwl360.com') {
                window.location.href = 'https://taiwan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'shandong.dtwl360.com') {
                window.location.href = 'https://shandong.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xjbt.dtwl360.com') {
                window.location.href = 'https://xjbt.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'ningxia.dtwl360.com') {
                window.location.href = 'https://ningxia.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'qingdao.dtwl360.com') {
                window.location.href = 'https://qingdao.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'jiangxi.dtwl360.com') {
                window.location.href = 'https://jiangxi.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hunan.dtwl360.com') {
                window.location.href = 'https://hunan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hebei.dtwl360.com') {
                window.location.href = 'https://hebei.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'gansu.dtwl360.com') {
                window.location.href = 'https://gansu.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'national.dtwl360.com') {
                window.location.href = 'https://national.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'neimeng.dtwl360.com') {
                window.location.href = 'https://neimeng.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xiamen.dtwl360.com') {
                window.location.href = 'https://xiamen.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'ningbo.dtwl360.com') {
                window.location.href = 'https://ningbo.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'jiangsu.dtwl360.com') {
                window.location.href = 'https://jiangsu.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xinjiang.dtwl360.com') {
                window.location.href = 'https://xinjiang.dtwl360.com/adm/user/login'
              } else if (window.location.host === 'guangdong.dtwl360.com') {
                window.location.href = 'https://guangdong.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'zhejiang.dtwl360.com') {
                window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'tianjin.dtwl360.com') {
                window.location.href = 'https://tianjin.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'guangxi.dtwl360.com') {
                window.location.href = 'https://guangxi.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hubei.dtwl360.com') {
                window.location.href = 'https://hubei.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'anhui.dtwl360.com') {
                window.location.href = 'https://anhui.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'qinghai.dtwl360.com') {
                window.location.href = 'https://qinghai.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'bdh.dtwl360.com') {
                window.location.href = 'https://bdh.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'sichuan.dtwl360.com') {
                window.location.href = 'https://sichuan.dtwl360.com/adm/user/login'
              }else if(window.location.host === 'huaxia.dtwl360.com') {
                window.location.href = 'https://huaxia.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'sx.dtwl360.com') {
                window.location.href = 'https://sx.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'liaoning.dtwl360.com') {
                window.location.href = 'https://liaoning.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'yunnan.dtwl360.com') {
                window.location.href = 'https://yunnan.dtwl360.com/adm/user/login'
              } else {
                Router.push({path: '/Login'})
              }
            }
          } else if (data.code == 105 || data.code == 106 || data.code == 107 || data.code == 108) {
            if (_isMobile()) {
              // 手机端
              Router.push({ path: "/mobile/login"})
            } else {
            //  if(location.pathname.indexOf('MapForPic')){
            //     // Router.push({path: '/Login'})
            //   }
              // pc端
              if (window.location.host === 'beijing.dtwl360.com') {
                window.location.href = 'https://beijing.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'chongqing.dtwl360.com') {
                window.location.href = 'https://chongqing.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'fujian.dtwl360.com') {
                window.location.href = 'https://fujian.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'henan.dtwl360.com') {
                window.location.href = 'https://henan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'taiwan.dtwl360.com') {
                window.location.href = 'https://taiwan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'shandong.dtwl360.com') {
                window.location.href = 'https://shandong.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xjbt.dtwl360.com') {
                window.location.href = 'https://xjbt.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'ningxia.dtwl360.com') {
                window.location.href = 'https://ningxia.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'qingdao.dtwl360.com') {
                window.location.href = 'https://qingdao.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'jiangxi.dtwl360.com') {
                window.location.href = 'https://jiangxi.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hunan.dtwl360.com') {
                window.location.href = 'https://hunan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hebei.dtwl360.com') {
                window.location.href = 'https://hebei.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'gansu.dtwl360.com') {
                window.location.href = 'https://gansu.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'national.dtwl360.com') {
                window.location.href = 'https://national.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'neimeng.dtwl360.com') {
                window.location.href = 'https://neimeng.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xiamen.dtwl360.com') {
                window.location.href = 'https://xiamen.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'ningbo.dtwl360.com') {
                window.location.href = 'https://ningbo.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'jiangsu.dtwl360.com') {
                window.location.href = 'https://jiangsu.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'xinjiang.dtwl360.com') {
                window.location.href = 'https://xinjiang.dtwl360.com/adm/user/login'
              } else if (window.location.host === 'guangdong.dtwl360.com') {
                window.location.href = 'https://guangdong.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'zhejiang.dtwl360.com') {
                window.location.href = 'https://zhejiang.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'tianjin.dtwl360.com') {
                window.location.href = 'https://tianjin.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'guangxi.dtwl360.com') {
                window.location.href = 'https://guangxi.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'hubei.dtwl360.com') {
                window.location.href = 'https://hubei.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'anhui.dtwl360.com') {
                window.location.href = 'https://anhui.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'qinghai.dtwl360.com') {
                window.location.href = 'https://qinghai.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'bdh.dtwl360.com') {
                window.location.href = 'https://bdh.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'sichuan.dtwl360.com') {
                window.location.href = 'https://sichuan.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'sx.dtwl360.com') {
                window.location.href = 'https://sx.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'liaoning.dtwl360.com') {
                window.location.href = 'https://liaoning.dtwl360.com/adm/user/login'
              } else if(window.location.host === 'yunnan.dtwl360.com') {
                window.location.href = 'https://yunnan.dtwl360.com/adm/user/login'
              } else {
                Router.push({path: '/Login'})
              }
            }
          } else {
            v.$message({
              showClose: true,
              message: data.message,
              type: 'warning'
            })
          }
        }
      }
  },
  doError(err, errCB, url) {
    console.log(url, '网络错误')
    // Router.push({path: '/Login'})
  },
}
export default Http



// WEBPACK FOOTER //
// ./src/Serves/net-api.js